import {Escola} from "./Escola";
import {Rol} from "./Rol";
import {Portada} from "./Portada";
import {Pagina} from "./Pagina";
import {Notificacio} from "./Notificacio";
import {Configuracio} from "./Configuracio";
import {MenuPantalla} from "./MenuPantalla";

class User {
    constructor(
        public key: number,
        public id: number,
        public value: number,
        public estat: number,
        public nom: string,
        public label: string,
        public escoles: Array<Escola>,
        public rol: Array<Rol>,
        public pagines: Array<Pagina>,
        public portada: Array<Portada>,
        public notificacions: Array<Notificacio>,
        public configuracions: Array<Configuracio>,
        public menus: Array<MenuPantalla>,
        public horaris: Array<any>,
    ) {
    }
}

const defaultUser: User = {
    key: 0,
    id: 0,
    value: 0,
    estat: 0,
    nom: "",
    label: "",
    escoles: [],
    pagines: [],
    rol: [],
    portada: [],
    notificacions: [],
    configuracions: [],
    horaris: [],
    menus: [],
};

export {User, defaultUser};
